// extracted by mini-css-extract-plugin
export default {"description":"AuditLog_description__awO37","itemsContainer":"AuditLog_itemsContainer__M3Hfa","scrollableContainer":"AuditLog_scrollableContainer__2IRXh"};